import { render, staticRenderFns } from "./DownloadDetails.vue?vue&type=template&id=2766dd3a&scoped=true"
import script from "./DownloadDetails.vue?vue&type=script&lang=js"
export * from "./DownloadDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2766dd3a",
  null
  
)

export default component.exports